import { render, staticRenderFns } from "./NeedLogin.vue?vue&type=template&id=519fad0e"
import script from "./NeedLogin.vue?vue&type=script&lang=js"
export * from "./NeedLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports